import { portalConstants } from '../constant';
export const portalAction = {
    setSettings,
    pageUpdated,
    portalIsLoading,
    showLoginAlert,
    showCustomLoginModal,
    showCustomRegisterModal,
    showSidebar,
    showContactForGameAccountAlert,
    affiliateValidated,
    googleScriptLoaded,
    getContactList,
    renderLoginBar,
    toggleGamePopup,
    setMenuTabSelected,
    setDropdownMenuOptionSelected,
    setIsOpenGamePopup,
    setFlagDepositCashMarketApi,
};

function setSettings(settings) {
    return (dispatch) => {
        window.portalSettings = settings;
        var hostName = window.location.host;
        if (settings?.features?.forceRedirectLanguageUrl?.hideByDomain?.[hostName]) {
            settings.features.hideLangPathUrl = true;
        }
        dispatch({ type: portalConstants.SET_PORTAL_SETTINGS, payload: settings });
    };
}

function pageUpdated(pathname, isFirstTimeLoad) {
    return (dispatch) => {
        dispatch({ type: portalConstants.PAGE_UPDATED, payload: { pathname: pathname, isFirstTimeLoad: isFirstTimeLoad } });
    };
}

function portalIsLoading(flag, showLoadingContent) {
    return (dispatch) => {
        dispatch({ type: portalConstants.PORTAL_LOADING, payload: { isLoading: flag, showLoadingContent: showLoadingContent } });
    };
}

function showLoginAlert(flag) {
    return (dispatch) => {
        document.documentElement.style.overflow = flag ? 'hidden' : '';
        dispatch({ type: portalConstants.SHOW_LOGIN_ALERT, payload: { showLoginAlert: flag } });
    };
}

function showCustomLoginModal(flag) {
    return (dispatch) => {
        dispatch({ type: portalConstants.SHOW_CUSTOM_LOGIN_MODAL, payload: { showCustomLoginModal: flag } });
    };
}

function showCustomRegisterModal(flag) {
    return (dispatch) => {
        dispatch({ type: portalConstants.SHOW_CUSTOM_REGISTER_MODAL, payload: { showCustomRegisterModal: flag } });
    };
}

function showContactForGameAccountAlert(flag) {
    return (dispatch) => {
        dispatch({ type: portalConstants.SHOW_CONTACT_FOR_GAME_ACCOUNT_ALERT, payload: { showContactForGameAccountAlert: flag } });
    };
}

function showSidebar(flag) {
    return (dispatch) => {
        return new Promise((resolve) => {
            resolve(dispatch({ type: portalConstants.SHOW_SIDEBAR, payload: flag }));
        });
    };
}

function affiliateValidated(flag) {
    return (dispatch) => {
        dispatch({ type: portalConstants.AFFILIATE_VALIDATED, payload: flag });
    };
}

function googleScriptLoaded(flag) {
    return (dispatch) => {
        dispatch({ type: portalConstants.GOOGLE_SCRIPT_LOADED, payload: flag });
    };
}

function getContactList(vm, language, type, contactDisplayType = 2) {
    const socialMediaList = ['Facebook', 'Instagram', 'Youtube', 'Twitter', 'Pinterest', 'Reddit'];
    const excludeCustomerServiceList = ['QRCode'];

    return (dispatch) => {
        return new Promise(function (resolve) {
            window.SPL_Content.getContact(language, type, undefined, true).then((res) => {
                if (res) {
                    for (let key in res) {
                        if (res[key].desc) {
                            // check typeof because some desc is object (e.g. QRcode)
                            res[key].descWithoutHtmlTag = res[key].desc;
                            if (typeof res[key].desc === 'string') {
                                res[key].descWithoutHtmlTag = res[key].desc.replace(/<(.|\n)*?>/g, '');
                            }
                        }
                    }
                    let returnList = res;
                    switch (contactDisplayType) {
                        case 2:
                            returnList = returnList.filter(function (el) {
                                return socialMediaList.indexOf(el.name) < 0;
                            });
                            break;
                        case 3:
                            returnList = returnList.filter(function (el) {
                                return socialMediaList.indexOf(el.name) >= 0;
                            });
                            break;
                        case 4:
                            // NOTE: get customer service list only
                            returnList = returnList.filter(function (el) {
                                return excludeCustomerServiceList.indexOf(el.name) < 0;
                            });
                            returnList = returnList.filter(function (el) {
                                return socialMediaList.indexOf(el.name) < 0;
                            });
                            break;
                        default:
                            break;
                    }
                    // Filter Name into correct name
                    for (let i = 0; i < returnList.length; i++) {
                        if (returnList[i].name === 'BasicDetailsTwitter') {
                            returnList[i].name = 'Twitter';
                        }
                    }
                    dispatch({ type: portalConstants.GET_CONTACT_LIST, payload: { contactList: returnList } });
                    resolve(returnList);
                } else {
                    dispatch({ type: portalConstants.GET_CONTACT_LIST, payload: { contactList: [] } });
                    resolve([]);
                }
            });
        });
    };
}

function renderLoginBar(flag) {
    return (dispatch) => {
        dispatch({ type: portalConstants.RENDER_LOGIN_BAR, payload: { renderLoginBar: flag } });
    };
}

function toggleGamePopup(flag) {
    return (dispatch) => {
        dispatch({ type: portalConstants.TOGGLE_GAME_POPUP, payload: { toggleGamePopup: flag } });
    };
}

function setIsOpenGamePopup(flag) {
    return (dispatch) => {
        dispatch({ type: portalConstants.IS_OPEN_GAME_POPUP, payload: { isOpenGamePopup: flag } });
    };
}

function setMenuTabSelected(menuTabSelected) {
    return (dispatch) => {
        dispatch({ type: portalConstants.SET_MENU_TAB_SELECTED, payload: { menuTabSelected: menuTabSelected } });
    };
}

function setDropdownMenuOptionSelected(dropdownMenuOptionSelected) {
    return (dispatch) => {
        dispatch({ type: portalConstants.SET_DROPDOWN_MENU_OPTION_SELECTED, payload: { dropdownMenuOptionSelected: dropdownMenuOptionSelected } });
    };
}

function setFlagDepositCashMarketApi(payload) {
    return (dispatch) => {
        dispatch({ type: portalConstants.SET_FLAG_DEPOSIT_CASHMARKET_API, payload });
    };
}
